import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './SpongeGourdPage.css';
import spongegourdLogo from '../images/spongegourd-logo.png';
import anushka from '../images/spongegourd-anushka-img.jpeg';
import deva from '../images/spongegourd-deva-img.jpeg';

const varieties = [
 
  {
    name: 'ANUSHKA',
    image: anushka,
    description: [
      'Maturity: 50-55 days after sowing',
      'Fruit weight: 100-130 g',
      'Fruit dimensions: 24-26 cm',
      'Plant vigor: Very strong',
      'Fruit shape: Cylindrical',
      'Fruit color: Dark green and glossy',
      'Early variety with excellent yield potential, suitable for warm and dry climates with good field disease and virus tolerance',
      'High fruit setting with A-class yield',
    ],
  },
  {
    name: 'DEVA',
    image: deva,
    description: [
      'Maturity: 45-50 days after sowing',
      'Fruit weight: 180-200 g',
      'Fruit dimensions: 26-30 cm',
      'Plant vigor: Strong',
      'Fruit shape: Cylindrical',
      'Fruit color: Light green',
      'Strong plant development suitable for warm and dry climates',
      'Light green cylindrical fruits with good yield potential',
    ],
  },
];

export default function SpongeGourdPage() {
  return (
    <ProductPatternPage
      title="Sponge Gourd"
      varieties={varieties}
      pageClass="spongegourd-page"
      heroImage={spongegourdLogo}
    />
  );
}
